import clsx from "clsx";
import type React from "react";
import { NavLink } from "react-router-dom";

interface SidebarItemProps {
  href: string;
  Icon: React.ComponentType<{ className?: string }>;
  label: string;
  active: boolean;
}

const SidebarItem = ({ href, Icon, label, active }: SidebarItemProps) => {
  return (
    <NavLink
      to={href}
      className={({ isActive }) =>
        clsx(
          isActive
            ? "bg-nav-active text-nav-active-fg"
            : "text-nav-text hover:text-nav-active-fg hover:bg-nav-active",
          "group flex gap-x-3 rounded-md p-3 text-[18px] leading-6 transition-colors"
        )
      }
    >
      {Icon && (
        <Icon
          className={clsx(
            active
              ? "text-nav-active-fg"
              : "text-nav-text group-hover:text-nav-active-fg",
            "h-6 w-6 shrink-0 transition-colors"
          )}
          aria-hidden="true"
        />
      )}

      {label}
    </NavLink>
  );
};

export default SidebarItem;
